/**
 * @author  Kheops Technologies SA <devops@kheops.ch>
 * @copyright Kheops Technologies SA
 */
import QuantityPicker from './QuantityPicker.vue'
export * from './QuantityPicker'
export default QuantityPicker
